module.exports = "/_next/static/images/box-36a6e7ed73a4c269f56e06d37e38cd31.jpg";